var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetCustody = function SvgAssetCustody(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 2.5H3.1a.6.6 0 0 0-.6.6v13.8a.6.6 0 0 0 .6.6h13.8a.6.6 0 0 0 .6-.6V3.1a.6.6 0 0 0-.6-.6Zm-.75 8.7H10.3V8.8h5.85v2.4Zm0 4.95H3.85V3.85h12.3V7.6H9.7a.6.6 0 0 0-.6.6v3.6a.6.6 0 0 0 .6.6h6.45v3.75ZM11.275 10a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z",
    fill: "#999"
  })));
};
export default SvgAssetCustody;